'use client'

import {
    COOKIE_CONSENT_STORAGE_KEY,
    CookieConsentStatus,
    CookieConsentValue,
    getCookieConsentCookieString,
    getCookieConsentMetaCookieStrings,
} from '@/lib/cookie-consent'
import faMessages from '@/messages/fa.json'
import Link from 'next/link'
import { useState } from 'react'

interface CookieConsentBannerProps {
    initialStatus: CookieConsentStatus
}

export default function CookieConsentBanner({ initialStatus }: CookieConsentBannerProps) {
    const [status, setStatus] = useState<CookieConsentStatus>(initialStatus)
    const t = faMessages.cookieConsent

    const setConsent = (nextValue: CookieConsentValue): void => {
        const now = new Date().toISOString()
        localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, nextValue)
        document.cookie = getCookieConsentCookieString(nextValue)
        const metaCookies = getCookieConsentMetaCookieStrings(now)
        for (const cookieValue of metaCookies) {
            document.cookie = cookieValue
        }
        setStatus(nextValue)
    }

    if (status !== 'unset') {
        return null
    }

    return (
        <div className="fixed inset-x-0 bottom-4 z-50 px-4">
            <div className="backdrop-blur bg-background/30 mx-auto flex w-full max-w-4xl flex-col gap-4 rounded-2xl border p-4 shadow-2xl md:flex-row md:items-center md:justify-between">
                <div className="space-y-2">
                    <p className="text-sm font-semibold">{t.title}</p>
                    <p className="text-muted-foreground text-sm">
                        {t.description}{' '}
                        <br />
                        <Link
                            href="/docs/privacy-policy"
                            className="underline underline-offset-4 hover:opacity-80">
                            {t.policyLink}
                        </Link>
                    </p>
                </div>
                <div className="flex shrink-0 items-center gap-2">
                    <button
                        type="button"
                        onClick={() => setConsent('declined')}
                        className="rounded-md border px-4 py-2 text-sm font-medium transition-opacity hover:opacity-85">
                        {t.decline}
                    </button>
                    <button
                        type="button"
                        onClick={() => setConsent('accepted')}
                        className="bg-primary text-primary-foreground rounded-md px-4 py-2 text-sm font-medium transition-opacity hover:opacity-85">
                        {t.accept}
                    </button>
                </div>
            </div>
        </div>
    )
}
